var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('BTable',{attrs:{"fields":_vm.fields,"items":_vm.rows,"hover":"","striped":""},scopedSlots:_vm._u([{key:"map",fn:function(ref){
var item = ref.item;
return [_c('a',{attrs:{"href":_vm.mapUrl(item.properties.latlng),"target":"_blank"}},[_vm._v(_vm._s(item.properties.latlng ? item.properties.latlng.split(',').join(', ') : ''))])]}}])})}
var staticRenderFns = []

export { render, staticRenderFns }